import Quill from '../quill'

const ImageBlot = Quill.import('formats/image')

// 扩展Quill内置的image格式
class EmojiBlot extends ImageBlot {
  // 创建自定义内容的DOM节点
  static create (value) {
    const node = super.create(value)
    node.setAttribute('src', ImageBlot.sanitize(value.url))
    if (value.width !== undefined) {
      node.setAttribute('width', value.width)
    }
    if (value.height !== undefined) {
      node.setAttribute('height', value.height)
    }
    node.setAttribute('style', 'vertical-align: middle;')
    node.setAttribute('data-text', value.text)
    node.setAttribute('isemoji', true)
    return node
  }

  // 返回options数据
  static value (node) {
    return {
      url: node.getAttribute('src'),
      width: node.getAttribute('width'),
      height: node.getAttribute('height'),
      text: node.getAttribute('data-text')
    }
  }
}

EmojiBlot.className = 'emoji'
EmojiBlot.blotName = 'emoji' // 定义自定义Blot的名字（必须全局唯一）
EmojiBlot.tagName = 'img' // 自定义内容的标签名

export default EmojiBlot



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/blot/emoji.js